
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M11.978 24C5.372 24 0 18.628 0 11.978 0 5.372 5.372 0 11.978 0s11.978 5.372 11.978 11.978C24 18.628 18.628 24 11.978 24z"}}),_c('path',{attrs:{"fill":"#3E529E","d":"M18.804 12.902v4.492c0 .132-.088.22-.22.22H16.25c-.132 0-.22-.088-.22-.22v-4.183c0-1.101-.396-1.85-1.365-1.85-.749 0-1.19.485-1.41 1.013-.043.176-.043.396-.043.66v4.36c0 .132-.088.22-.22.22h-2.335c-.132 0-.22-.088-.22-.22 0-1.1.044-6.473 0-7.75 0-.132.088-.22.22-.22h2.29c.133 0 .22.088.22.22V10.612v-.043c.353-.573 1.013-1.366 2.467-1.366 1.805.044 3.17 1.19 3.17 3.7zM6.474 17.57h2.334c.132 0 .22-.088.22-.22V9.644c0-.132-.088-.22-.22-.22H6.474c-.132 0-.22.088-.22.22v7.75c.044.088.132.176.22.176zM7.574 8.411a1.453 1.453 0 100-2.906 1.453 1.453 0 000 2.906z"}})])
          )
        }
      }
    